import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => { setUser(r.data); localStorage.setItem("bm-last-user", JSON.stringify({ name: r.data.name, email: r.data.email, role: r.data.role })); }).catch((e) => {
      const last = !e.response && localStorage.getItem("bm-last-user");
      setUser(last ? { ...JSON.parse(last), offline: true } : false);
    });
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    setUser(r.data);
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("bm-last-user");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
